import styled from 'styled-components';

export const ExpandableLabelsRoot = styled.div`
  display: flex;
  column-gap: 8px;
  row-gap: 10px;
  flex-wrap: wrap;
`;
